import { render, staticRenderFns } from "./BookingListItem.vue?vue&type=template&id=228dd516&scoped=true"
import script from "./BookingListItem.vue?vue&type=script&lang=js"
export * from "./BookingListItem.vue?vue&type=script&lang=js"
import style0 from "./BookingListItem.vue?vue&type=style&index=0&id=228dd516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228dd516",
  null
  
)

export default component.exports